import React from 'react'
import Header from '../../Header'
import ComingSoon from '../../../../../CustomComponents/ComingSoon'
import Footer from '../../../Footer/Footer'

const ReturnExchange = () => {
  return (
    <>
    <Header/>
    <ComingSoon/>
    <Footer/>

    </>
  )
}

export default ReturnExchange
